// extracted by mini-css-extract-plugin
module.exports = {"text":"textcolor_text__Ng9mJ"};